export const ALLOWED_USER_ROLE = 'admin';
